import React from 'react';
import InputAsyncInformed from '../InputAsyncInformed';
import { fetchPaginatedStudentCurriculumOptions } from '../../services/curricula-services';

const StudentCurriculumInputAsync = ({ params, ...props }) => {
  return (
    <InputAsyncInformed
      defaultOptions
      placeholder="Selecionar"
      loadOptions={(search) =>
        fetchPaginatedStudentCurriculumOptions({ search, ...params })
      }
      {...props}
    />
  );
};

export default StudentCurriculumInputAsync;
